import { preffixTestIds } from 'utility/e2e'

export const ONE_UI_PROVIDER_TEST_IDS = preffixTestIds('one-ui')({
  CONTROL_LEFT: 'l',
  CONTROL_RIGHT: 'r',
})
